﻿import Splide from '@splidejs/splide';

export const initLocationPage = () => {
  new Splide('.service-splide', {
    type: 'loop',
    perPage: 3,
    perMove: 1,
    gap: '30px',
    autoplay: true,
    speed: 500,
    interval: 5000,
    pagination: false,
    breakpoints: {
      1024: {
        perPage: 3,
      },
      767: {
        perPage: 2,
      },
      640: {
        perPage: 1,
      },
    },
  }).mount();
};
